import { render, staticRenderFns } from "./AreaProtegida.vue?vue&type=template&id=8499139a&"
import script from "./AreaProtegida.vue?vue&type=script&lang=js&"
export * from "./AreaProtegida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports